import React from 'react';
import {
  leaderboardLeague,
  leaderboardTierBoundary,
} from '@utils/constants/leaderboard.constants';
import { CDN_URL } from '@utils/constants/url.constants';
import { useIsJCUser } from '@hooks/user.hook';

export interface LeaderboardBannerProps {
  tier: number | string;
}

const LeaderboardBanner = (props: LeaderboardBannerProps) => {
  const { isJC } = useIsJCUser({ subjectId: undefined, generalPage: true });
  const bannerBg =
    CDN_URL +
    'assets/images/leaderboard-league/bg-' +
    leaderboardLeague(props.tier).toLowerCase() +
    '.svg';
  const bannerCrown =
    CDN_URL +
    'assets/images/leaderboard-league/crown-' +
    leaderboardLeague(props.tier).toLowerCase() +
    '.svg';
  const boyIllustration =
    CDN_URL + 'assets/images/leaderboard-league/boy-illustration.svg';

  const JCbannerCrown = `${CDN_URL}assets/images/leaderboard-league/crown-${leaderboardLeague(
    props.tier,
  ).toLowerCase()}.svg`;

  const JCbannerBgColor = {
    bronze: 'bg-[#CB7F32]',
    silver: 'bg-[#9B9B9B]',
    gold: 'bg-[#CFAE00]',
    diamond: 'bg-[#85AEB7]',
    platinum: 'bg-[#8099BB]',
    master: 'bg-[#0755AE]',
  };

  const getLeagueBgClass = () => {
    const league = leaderboardLeague(
      props.tier,
    ).toLowerCase() as keyof typeof JCbannerBgColor;
    const bgColor = JCbannerBgColor[league];
    return bgColor ?? 'bg-[#000000]';
  };

  return (
    <div className={'relative w-full h-[88px]'}>
      <div className={'w-full h-full relative rounded-2xl overflow-hidden'}>
        {isJC !== undefined &&
          (isJC ? (
            <div
              className={`h-[88px] rounded-xl w-full ${getLeagueBgClass()}`}
            ></div>
          ) : (
            <img
              src={bannerBg}
              alt=""
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[88px] object-none"
            />
          ))}

        {isJC === false && (
          <img
            src={bannerCrown}
            alt={''}
            className={
              'absolute right-[36px] top-1/2 -translate-y-1/2 max-md:hidden w-[76px]'
            }
          />
        )}
      </div>
      {isJC !== undefined &&
        (isJC ? (
          <img
            src={JCbannerCrown}
            alt=""
            className="absolute right-[36px] top-1/3 -translate-y-1/2 max-md:hidden max-lg:hidden w-[110px]"
          />
        ) : (
          <img
            src={boyIllustration}
            alt={''}
            className={
              'absolute left-[0px] bottom-0 max-md:hidden w-[136px] h-[102px]'
            }
          />
        ))}

      <div
        className={`absolute text-neutral-whiteboard ${
          isJC === false
            ? 'text-center left-1/2 -translate-x-1/2'
            : 'text-left ml-10'
        } top-1/2 -translate-y-1/2 md:w-[66%] max-md:w-[264px]`}
      >
        <div className={'uppercase font-black text-lg leading-6 mb-2'}>
          {leaderboardLeague(props.tier) + ' League'}
        </div>
        <div className={'text-sm leading-5 font-medium'}>
          {props.tier != 5
            ? 'Earn ' +
              leaderboardTierBoundary(props.tier) +
              ' Bubbles this season to enter the '
            : 'Earn ' +
              leaderboardTierBoundary(props.tier - 1) +
              ' Bubbles this season to stay in the '}
          {props.tier != 5 ? (
            <>
              <span className={'font-bold'}>
                {leaderboardLeague(parseInt(props.tier as string) + 1)} League
              </span>
              !
            </>
          ) : (
            <>
              <span className={'font-bold'}>
                {leaderboardLeague(props.tier)} League
              </span>
              !
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeaderboardBanner;
